import React from 'react'
const ErrorDialogContext = React.createContext(null)
export default ErrorDialogContext